import { Edit,SimpleForm,TextInput,DateInput,BooleanInput, TabbedForm, FormTab } from "react-admin";
import ImageSelectorField from "../imageSelectorField";

 export const NewsEdith = (props)=>(
    <Edit {...props}>
        <TabbedForm>
          <FormTab>
            <TextInput source="title" label="Título" fullWidth />
            <TextInput source="content" label="Contenido" multiline fullWidth />
            
            <DateInput source="date" label="Fecha" />
            <BooleanInput 
            source="isPublished" 
            label="Publicado" 
            parse={v =>!!v}
            format={v=>!!v}
            />
            <ImageSelectorField/>
            <TextInput source="image" style={{display:'none'}}/>
          </FormTab>
        </TabbedForm>

    </Edit>
);


